import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faArrowUp} from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from 'styled-components'; // Access theme context

const FloatingIcons = () => {
  const theme = useContext(ThemeContext); // Get colors from the theme
  const isMobile = window.innerWidth <= 768;

  const sharedStyle = {
    position: 'fixed',
    backgroundColor: theme.cardBackground, // Dynamically use the theme's card background
    color: theme.color, // Dynamically set the icon color
    borderRadius: '50%',
    padding: isMobile ? '10px' : '15px',
    boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    zIndex: 9999,
    transition: 'all 0.3s ease-in-out',
    opacity: '0.5'
  };

  const mailIconStyle = {
    ...sharedStyle,
    bottom: isMobile ? '80px' : '100px', // Slightly above the arrow
    right: isMobile ? '16px' : '32px',
  };

  const WAIconStyle = {
    ...sharedStyle,
    bottom: isMobile ? '16px' : '32px', // Slightly above the arrow
    right: isMobile ? '16px' : '32px',
  };

  const arrowIconStyle = {
    ...sharedStyle,
    bottom: isMobile ? '16px' : '32px', // Bottom-left corner
    left: isMobile ? '16px' : '32px',
  };

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Mail Icon */}
      <div style={mailIconStyle}>
        <a href="mailto:contact@jr-ai-consulting.com" style={{ color: theme.color }}> {/* Ensure link color matches the theme */}
          <FontAwesomeIcon icon={faEnvelope} size={isMobile ? 'lg' : '2x'} />
        </a>
      </div>

      {/* WA Icon */}
      <div style={WAIconStyle}>
        <a href="https://wa.me/+33672260278" style={{ color: theme.color }}> {/* Ensure link color matches the theme */}
          <FontAwesomeIcon icon={faWhatsapp} size={isMobile ? 'lg' : '2x'} />
        </a>
      </div>

      {/* Arrow Icon */}
      <div style={arrowIconStyle} onClick={handleScrollToTop}>
        <FontAwesomeIcon icon={faArrowUp} size={isMobile ? 'lg' : '2x'} />
      </div>
    </>
  );
};

export default FloatingIcons;
